// §29.7 / §9.1 — Phalanx as an in-process app.
//
// Manifest only (D-247): the engine, the view, the CSS and the sprite sheet all live behind the
// thunk, so a desktop that never opens this window never downloads any of it (D-199, D-367).
//
// Not a factory. Phalanx is single-player — §30.1's multiplayer allowlist does not name it — so it
// needs no `PlayShellAccess` and taking one would imply a session it never opens.
import type { InProcessApp } from '@hangar/shared';
import { createLazyApp } from '@/gamekit/lazy';

export function createPhalanxApp(): InProcessApp {
  return createLazyApp({
    app: {
      id: 'phalanx',
      name: 'Phalanx',
      // §29.1 (D-379) — the glyph is fixed by the roster, not chosen here.
      icon: { glyph: 'shield', hue: 205 },
      keywords: ['invaders', 'aliens', 'shooter', 'cannon', 'game', 'arcade'],
      category: 'Arcade',
      // §29.1 (D-369) — the sub-group header this title sits under in the launcher and the Store.
      group: 'Action',
      requiresAuth: true,
      // Fixed-aspect letterboxed canvas (D-229, D-374): the fleet's margins are the game, and a
      // free-resizing playfield would hand a wide window more room to dodge in.
      window: { width: 720, height: 760, minWidth: 460, minHeight: 480, multiWindow: false },
      jumpList: [{ id: 'new-game', label: 'New game' }],
    },
    load: () => import('./Phalanx'),
  });
}
